import { Stack } from '@mui/material'
import { EFTypography } from '../EFTypography'
import { ILabeledContentProps } from './EFLabeledContent.model'

export function EFLabeledContent({ label, value }: ILabeledContentProps) {
  return (
    <Stack paddingY={1}>
      <EFTypography
        variant='body1'
        marginY={1}
      >
        {label}
      </EFTypography>
      <EFTypography
        variant='body1'
        fontWeight={600}
        marginY={1}
      >
        {value}
      </EFTypography>
    </Stack>
  )
}
